<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header d-flex justify-content-between">
            <div>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === null,
                  'btn-primary': filter.status !== null,
                }"
                @click="changeFilter({ status: null })"
              >
                Все
              </button>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === 0,
                  'btn-info': filter.status !== 0,
                }"
                @click="changeFilter({ status: 0 })"
              >
                Требующие действия
              </button>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === 1,
                  'btn-success': filter.status !== 1,
                }"
                @click="changeFilter({ status: 1 })"
              >
                Подтвержденные
              </button>
              <button
                class="btn mr-2"
                :class="{
                  'btn-secondary': filter.status === 2,
                  'btn-danger': filter.status !== 2,
                }"
                @click="changeFilter({ status: 2 })"
              >
                Отмененные
              </button>
            </div>
            <h4 class="pull-right">Ваши действия</h4>
          </header>
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <paginate
                :page-count="filter.count"
                :page-range="3"
                :margin-pages="2"
                :click-handler="getCurrentPage"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link-item'"
                :prev-class="'prev-pagination'"
                :prev-link-class="'prev-link-pagination'"
                :next-class="'next-pagination'"
                :next-link-class="'next-link-pagination'"
              ></paginate>
            </div>
            <table
              class="table table-bordered table-striped"
              id="serverDataTable"
            >
              <thead>
                <tr>
                  <th>id</th>
                  <th>Коментарий к Подтверждению</th>
                  <th>Коментарий</th>
                  <th>Подтверждено</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(val, index) in actions"
                  :key="index"
                  :class="{
                    'bg-danger': val.status === 2,
                    'bg-warning': val.status === 0,
                    'bg-success': val.status === 1,
                  }"
                >
                  <td>{{ val.id }}</td>
                  <td>{{ val.comment }}</td>
                  <td>
                    {{ val.action.action + " - " + val.action.created_at }}
                  </td>
                  <td>{{ val.user.name }} - {{ val.verified_at }}</td>
                  <td>
                    <button
                      class="btn btn-primary mr-1"
                      @click="
                        changeModalData(val.route.action.as.split('.'), index)
                      "
                    >
                      посмотреть
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row d-flex justify-content-center">
            <paginate
              :page-count="filter.count"
              :page-range="3"
              :margin-pages="2"
              :click-handler="getCurrentPage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-pagination'"
              :prev-link-class="'prev-link-pagination'"
              :next-class="'next-pagination'"
              :next-link-class="'next-link-pagination'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
    <renderModel
      :modalData="modalData"
      :actions="actions"
      @update="updateFromModels"
    ></renderModel>
  </main>
</template>

<script>
import { GET, POST } from "@/shared/api";
import request_data from "@/views/validateAction/requestView/request_data";
import renderModel from "@/views/validateAction/requestView/renderModel";
export default {
  components: { request_data, renderModel },
  data() {
    return {
      modalData: {},
      actions: [],
      confirmation: false,

      filter: {
        user_id: null,
        status: 0,
        mode: 0,
        page: 1,
        perpage: 10,
        count: 0,
      },
      totalCount: 0,
    };
  },
  methods: {
    updateFromModels(state) {
      if (typeof state === "object") {
        switch (state.action) {
          case "gAA":
            this.getActiveActions();
            break;
        }
      }
    },
    changeModalData(route, index) {
      this.modalData = {
        route: route,
        index: index,
      };
    },
    changeFilter(filter) {
      let changed = false;
      if (typeof filter.status !== "undefined") {
        this.filter.status = filter.status;
        changed = true;
      }
      if (typeof filter.perpage !== "undefined") {
        this.filter.perpage = filter.perpage;
        changed = true;
      }

      if (changed) {
        this.filter.page = 1;
        this.getActiveActions();
      }
    },
    getActiveActions() {
      GET(this.filter, "/myValidActions", this, false).then((response) => {
        let result = response.data.data;
        console.log("result", result);

        this.totalCount = response.data.total;
        this.filter.count = Math.ceil(this.totalCount / this.filter.perpage);

        result.forEach((val, index) => {
          val.request_data = JSON.parse(val.request_data);
          val.route = JSON.parse(val.route);
          if (typeof val.user == "undefined" || val.user == null) {
            val.user = {
              name: null,
            };
          }

          if (typeof val.action === "undefined" || val.action === null) {
            val.action = {
              action: null,
              user: {
                name: null,
              },
            };
          }
        });

        this.actions = result;
      });
    },
    getCurrentPage(pageNumber) {
      this.filter.page = pageNumber;
      this.getActiveActions();
    },
  },

  mounted() {
    let user_data = JSON.parse(localStorage.getItem("user"));
    if (typeof user_data.id !== "undefined") {
      this.filter.user_id = user_data.id;
      this.getActiveActions();
    }
  },
};
</script>

<style scoped></style>
